import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

export default function PaymentCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/billing');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-900 py-12 px-4">
      <div className="w-full max-w-md">
        <Card>
          <div className="text-center space-y-6">
            <div className="flex justify-center">
              <XCircle className="w-16 h-16 text-red-500 dark:text-red-400" />
            </div>

            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Payment Cancelled
              </h1>
              <p className="text-gray-500 dark:text-slate-400">
                No charges were made to your account. You can try again whenever you're ready.
              </p>
            </div>

            <div className="space-y-3">
              <Button className="w-full" onClick={() => navigate('/billing')}>
                Try Again
              </Button>
              <Button
                className="w-full"
                variant="outline"
                onClick={() => navigate('/')}
              >
                Go to Dashboard
              </Button>
              <p className="text-sm text-gray-400 dark:text-slate-500">
                Redirecting to billing in 10 seconds...
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
